/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../BaseCom"
import Breadcrumb from "../Breadcrumb";
import Card from "../Card";
import FormInput from "../FormInput";
import LoadingAlert from "../LoadingAlert";
import { qreq } from "../../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { SidebarGlobal } from "../_Sidebar";
import MessageDialog from "../MessageDialog";
import React from "react";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import L from "../Lang";

class ProjectView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            item: {}
        };

        this.submitRef = React.createRef();
    }

    componentDidMount() {
        this.load();
        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-primary" onClick={() => this.submitRef.current.click()}><FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button></>);

    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = () => {
        this.setState({ loading: true });
        if (this.props.params.id) {
            qreq.get('/api/project/get/' + this.props.params.id, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else if (j.item)
                    this.setState({ item: j.item });
                this.setState({ loading: false });
            }, e => {
                this.unkownErrorCallback();
                this.goBack();
                this.setState({ loading: false });
            });
        }
        else
            this.setState({ item: {}, loading: false });
    }


    submit = (e) => {
        if (e)
            e.preventDefault();

        var item = { ...this.state.item };


        this.setState({ saving: true });


        qreq.post('/api/project/save', item, (j) => {
            if (j.errorCode !== 0)
                alert(j.errorMessage);
            else
                this.goBack();

            this.setState({ saving: false });
        });
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1><L>Project</L></h1><LoadingAlert /></div>);

        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1><L>Project</L></h1>
                <Breadcrumb path={[['Projects', '/project'], [this.props.params.id ? 'Edit' : 'New']]} />
                <div className="row">
                    <div className="col-lg-12">
                        <Card title="Project Info">
                            <FormInput model={this.state.item} name="name" label="Project Name" type="text" required />
                        </Card>
                    </div>
                </div>
                {this.state.saving ? (<MessageDialog title="Saving" message="Processing..." />) : (<>
                    <div className="d-none">
                        <button ref={this.submitRef} type="submit" className="btn btn-success d-inline-block"><L>Save</L></button>
                        <button type="button" className="btn btn-secondary d-inline-block ms-1" onClick={this.goBack}><L>Cancel and Go Back</L></button>
                    </div></>)}
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(ProjectView);